<template>
	<div class="problemList">
		<div class="flex-title">
			回复列表
			<div class="headOpter">
				<el-tooltip class="item" effect="dark" content="查看用户列表" placement="top-start">
					<i class="el-icon-user" @click="openUserInfo"></i>
				</el-tooltip>

				<i class="el-icon-close close" @click="openUserInfo"></i>
			</div>
		</div>
		<div class="quickList">
			<div class="sechList">
				<el-input placeholder="请输入内容" v-model="searchQuick" class="input-with-select">
					<el-button
						slot="append"
						icon="el-icon-search"
						@keyup.enter.native="searchKeyWord"
						@click="searchKeyWord"
					></el-button>
				</el-input>
			</div>
			<ul class="quickul" v-if="datas.length>0" v-loading="quicklistLoading">
				<li v-for="(item,key) in datas">
					<span class="keyword">{{item.keyWord}}</span>
					<el-tooltip class="item" effect="dark" :content="item.content" placement="top-start">
						<span class="content">{{item.content}}</span>
					</el-tooltip>
					<span class="btuSend">
						<el-tag size="mini" @click="sendQuick(item)">发送</el-tag>
					</span>
				</li>
			</ul>
			<div v-if="datas.length==0" class="noTime">暂无数据</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'problemList',
	props: [],
	data() {
		return {
			datas: [],
			searchQuick: '',
			quicklistLoading: false,
			isUser: true
		}
	},
	props: {
		quickObject: {
			type: Object,
			default: () => {
				id: 0
			}
		},
		reply: {
			type: String,
			default: ''
		},
		quickTagTypes: {
			type: Number,
			default: 1
		}
	},
	watch: {
		quickObject: {
			handler(newName, oldName) {
				let vm = this
				if (newName) {
					vm.quickObject = newName
					vm.searchKeyWord()
				}
			},
			deep: true
		},
		searchQuick: function(val) {
			if (val == '') {
				this.searchKeyWord()
			}
		},
		quickTagTypes: function(val) {
			if (val == 1) {
				this.isUser = true
			} else {
				this.isUser = false
			}
		}
	},
	created: function() {
		this.getProblem()
	},
	methods: {
		getProblem(id) {
			let vm = this
			vm.quicklistLoading = true
			this.axios
				.get('QuickReply/GetQukRly', {
					params: { groupId: vm.quickObject.id }
				})
				.then(function({ data }) {
					vm.datas = data.data
					vm.datas = vm.datas.concat(data.data)
					vm.quicklistLoading = false
				})
		},
		searchKeyWord() {
			let vm = this
			vm.quicklistLoading = true
			this.axios
				.get('QuickReply/searchQukRly', {
					params: {
						groupId: vm.quickObject.id,
						content: vm.searchQuick,
						isUser: vm.isUser
					}
				})
				.then(function({ data }) {
					if (data.result) {
						vm.datas = data.data
					}
					vm.quicklistLoading = false
				})
		},
		sendQuick(val) {
			document.getElementById('charInput').append(val.content)
			this.$emit('selectedReply', val)
		},
		openUserInfo() {
			this.$emit('openUserInfo')
		}
	}
}
</script>
<style scoped>
.problemList {
	width: 18%;
}
.headOpter:hover {
	cursor: pointer;
}
.flex-title {
	display: -webkit-flex;
	/*在webkit内核的浏览器上使用要加前缀*/
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 42px;
	line-height: 42px;
	border-bottom: 1px solid #ddd;
	padding: 0 15px;
}
.quickList {
	width: 100%;
	height: 85%;
}
.quickul {
	overflow-y: auto;
	overflow-x: hidden;
	height: 100%;
}
.quickul li {
	padding: 7px;
	color: #666;
}
.quickul li:hover {
	padding: 7px;
	cursor: pointer;
	color: black;
	background-color: #ddd;
}
.quickul li:hover .btuSend {
	display: inline-block;
}
.btuSend {
	float: right;
	margin-top: -3px;
	margin-right: 5px;
	display: none;
}
.keyword {
	width: 15%;
	display: inline-block;
}
.content {
	width: 60%;
	display: inline-block;
	word-break: keep-all;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.problemList {
	height: 100%;
}
/*滚动条样式*/
::-webkit-scrollbar {
	width: 5px;
}

::-webkit-scrollbar-track {
	border-radius: 5px;
}

::-webkit-scrollbar-thumb {
	background-color: #d6d6d6;
	border-radius: 5px;
}
.sechList {
	padding: 6px 5px;

	border-bottom: 1px solid #ddd;
}
.noTime {
	padding: 15px;
	text-align: center;
	color: #666;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/talks/problemList.vue